import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const supplierEvaluationApi = createApi({
  reducerPath: "supplierEvaluation",
  baseQuery: createBaseQuery(),
  tagTypes: ["Supplier"],
  endpoints(builder) {
    return {

      // GET
      getSupplier: builder.query({
        query: (id) => ({
          url: `SupplierEvaluation?vendorId=${id}`,
          method: "GET",
        }),
        providesTags: ["Supplier"],
      }),

      // GET
      getSupNDA: builder.query({
        query: (id) => ({
          url: `SupplierEvaluation/NonDisclosureAgreement?vendorId=${id}`,
          method: "GET",
        }),
        providesTags: ["Supplier"],
      }),

      // GET
      getSupCobc: builder.query({
        query: (id) => ({
          url: `SupplierEvaluation/CodeOfBuConduct?vendorId=${id}`,
          method: "GET",
        }),
        providesTags: ["Supplier"],
      }),



      // POST

      postSupplier: builder.mutation({
        query: (data) => ({
          url: "SupplierEvaluation/Post2",
          method: "POST",
          body: data,
        }),
        providesTags: ["Supplier"],
      }),

      submitSupplier: builder.mutation({
        query: (data) => ({
          url: "SupplierEvaluation/Submit2",
          method: "POST",
          body: data,
        }),
        providesTags: ["Supplier"],
      }),

      postUpdateVendor: builder.mutation({
        query: (data) => ({
          url: `SupplierEvaluation/UpdateVendor?taxId=${data}`,
          method: "POST",
        }),
        providesTags: ["Supplier"],
      }),

      //

      getSupplierCompany: builder.query({
        query: (id) => ({
          url: `SupplierEvaluation/CompanyInformation?vendorId=${id}`,
          method: "GET",
        }),
        providesTags: ["Supplier"],
      }),

      getSupplierBank: builder.query({
        query: (id) => ({
          url: `SupplierEvaluation/BankDetails?vendorId=${id}`,
          method: "GET",
        }),
        providesTags: ["Supplier"],
      }),

      getSupplierDueDiligence: builder.query({
        query: (id) => ({
          url: `SupplierEvaluation/DueDiligence?vendorId=${id}`,
          method: "GET",
        }),
        providesTags: ["Supplier"],
      }),


      getSupplierPrequalification: builder.query({
        query: (args) => {
          // Destructuring Object
          const { ids, vendorId } = args;
          return {
            url: `SupplierEvaluation/Prequalification?id=${ids}&vendorId=${vendorId}`,
          };
        },
        providesTags: ["Supplier"],
      }),

    };
  },
});

export const {
  useGetSupplierQuery, usePostSupplierMutation, useGetSupNDAQuery, usePostUpdateVendorMutation,
  useGetSupplierCompanyQuery, useGetSupCobcQuery, useGetSupplierBankQuery, useGetSupplierDueDiligenceQuery, useGetSupplierPrequalificationQuery, useSubmitSupplierMutation
} = supplierEvaluationApi;

export { supplierEvaluationApi };